import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { AppLayout } from './layout/AppLayout.js';
import { RequireAdmin, RequireAuth } from './layout/guards.js';
import { AuthProvider } from './context/AuthContext.js';
import { ThemeProvider } from './context/ThemeContext.js';
import { ToastProvider } from './context/ToastContext.js';
import { AdminPage } from './pages/AdminPage.js';
import { FeedPage } from './pages/FeedPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import { RosterPage } from './pages/RosterPage.js';

export function App() {
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: { queries: { retry: 1 } } }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <ToastProvider>
            <Router>
              <Routes>
                <Route element={<AppLayout />}>
                  <Route index element={<RosterPage />} />
                  <Route path="login" element={<LoginPage />} />
                  <Route
                    path="feed"
                    element={
                      <RequireAuth>
                        <FeedPage />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="admin"
                    element={
                      <RequireAdmin>
                        <AdminPage />
                      </RequireAdmin>
                    }
                  />
                  <Route path="*" element={<NotFoundPage />} />
                </Route>
              </Routes>
            </Router>
          </ToastProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
